


































































































import { Component } from 'vue-property-decorator';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import Mixin from '@/mixin';
import VNavigator from '@/components/items/VNavigator.vue';
import { validationMixin } from 'vuelidate';
import authService from '@/services/common/auth.service';
import popupModule from '@/store/modules/common/popup.module';
import popup from '@/data/popup.json';
import VPasswordInput from '@/components/items/VPasswordInput.vue';

@Component({
  mixins: [validationMixin],
  name: 'change-password',
  components: { VPasswordInput, VNavigator },
  validations: {
    currentPassword: { required, minLength: minLength(6) },
    password: { required, minLength: minLength(6) },
    passwordConfirm: { required, samAsPassword: sameAs('password') }
  }
})
export default class ChangePassword extends Mixin {
  public currentPassword = '';
  public password = '';
  public passwordConfirm = '';
  public token = '';

  public async submit() {
    this.$v?.$touch();
    if (!(this.$v?.$error || this.$v?.$invalid)) {
      await authService.changePassword({
        currentPassword: this.currentPassword,
        newPassword: this.password
      });
      await popupModule.initPopup(popup.changePassword);
      await popupModule.setShowPopup(true);
    }
  }

  created() {
    this.token = this.$route.params.key;
  }
}
